// extracted by mini-css-extract-plugin
export var centerText = "_c4-8";
export var container = "_c4-0";
export var doughnutContainer = "_c4-7";
export var legend = "_c4-a";
export var legendItemColorDisplay = "_c4-b";
export var legendItemLabel = "_c4-d";
export var legendItemValue = "_c4-c";
export var lg = "_c4-5";
export var maxWidth = "_c4-9";
export var md = "_c4-4";
export var responsive = "_c4-6";
export var sm = "_c4-3";
export var xs = "_c4-2";
export var xxs = "_c4-1";